module.exports = __webpack_public_path__ + "3ec6c2fd4921a6a0568725e5726dc4d3.png";